import { REDUCE_PAYMENT_EMAIL } from '../../constants/actions/payment';

export function reducePaymentEmail(payload) {
    return {
        type: REDUCE_PAYMENT_EMAIL,
        payload,
    };
}
